import Client from '@/services/api/internal/tools/client';
import { errorHandler } from '@/business/apiTreatment/response/baseAPITreatment';

export function getAlerts(propertyId) {
  const url = `${process.env.MYPREDITY_BASE_URI}/properties/${propertyId}/hypervision_alerts`;
  return Client.get(url, {
    __retry: { nbLeft: 2, timeout: 2000 },
  })
    .then((response) => {
      return response.data.items;
    })
    .catch(errorHandler);
}

export function getAlertsFromList(idList) {
  const url = `${process.env.MYPREDITY_BASE_URI}/properties/hypervision_alerts`;
  return Client.post(
    url,
    { properties: idList },
    {
      __retry: { nbLeft: 2, timeout: 2000 },
    }
  )
    .then((response) => {
      return response.data.hypervision_alerts;
    })
    .catch(errorHandler);
}
